import ScheduleDay from './ScheduleDay';
import type { ScheduleDayProps } from './types';

interface Props {
  days: Array<ScheduleDayProps>;
  pixels_per_hour?: number;
  show_day_labels?: boolean;
  hiddenDays: Array<string>;
  onToggleDayVisibility: (date: string) => void;
}

const Schedule = (props: Props): React.ReactElement => {
  const { days, pixels_per_hour = 120, show_day_labels = true } = props;

  return (
    <div className="schedule">
      {days.map(day => (
        <ScheduleDay
          key={day.date}
          day={day}
          pixelsPerHour={pixels_per_hour}
          showDayLabels={show_day_labels}
          collapsed={props.hiddenDays.includes(day.date)}
          onShow={() => props.onToggleDayVisibility(day.date)}
        />
      ))}
    </div>
  );
};

export default Schedule;
